var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#73AF00"
    },
    points: "0,512 512,512 512,13.474 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "512,0 487.834,0 0,487.834 0,512 24.166,512 512,24.166 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M62.983,41.744l-6.133,18.39l-19.385,0.15c-1.859,0.014-2.63,2.387-1.134,3.491l15.595,11.516   l-5.847,18.483c-0.561,1.772,1.457,3.239,2.97,2.158L64.82,84.659l15.77,11.273c1.512,1.081,3.53-0.385,2.97-2.158l-5.847-18.483   l15.595-11.516c1.495-1.104,0.725-3.477-1.134-3.491l-19.385-0.15l-6.133-18.39C66.066,39.98,63.571,39.98,62.983,41.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M210.654,41.744l-6.133,18.39l-19.385,0.15c-1.859,0.014-2.63,2.387-1.134,3.491l15.595,11.516   l-5.847,18.483c-0.561,1.772,1.457,3.239,2.97,2.158l15.771-11.273l15.771,11.273c1.512,1.081,3.53-0.385,2.97-2.158l-5.848-18.483   l15.595-11.516c1.495-1.104,0.725-3.477-1.134-3.491l-19.385-0.15l-6.133-18.39C213.737,39.98,211.243,39.98,210.654,41.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M136.819,107.543l-6.133,18.39l-19.385,0.15c-1.859,0.014-2.63,2.387-1.134,3.491l15.595,11.516   l-5.847,18.483c-0.561,1.772,1.457,3.239,2.97,2.158l15.771-11.273l15.771,11.273c1.512,1.081,3.53-0.385,2.97-2.158l-5.848-18.483   l15.595-11.516c1.495-1.104,0.725-3.477-1.134-3.491l-19.385-0.15l-6.133-18.39C139.901,105.779,137.407,105.779,136.819,107.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M62.983,173.342l-6.133,18.39l-19.385,0.15c-1.859,0.014-2.63,2.387-1.134,3.491l15.595,11.516   l-5.847,18.483c-0.561,1.772,1.457,3.239,2.97,2.158l15.771-11.273l15.77,11.273c1.512,1.081,3.53-0.385,2.97-2.158l-5.847-18.483   l15.595-11.516c1.495-1.104,0.725-3.477-1.134-3.491l-19.385-0.15l-6.133-18.39C66.066,171.579,63.571,171.579,62.983,173.342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M210.654,173.342l-6.133,18.39l-19.385,0.15c-1.859,0.014-2.63,2.387-1.134,3.491l15.595,11.516   l-5.847,18.483c-0.561,1.772,1.457,3.239,2.97,2.158l15.771-11.273l15.771,11.273c1.512,1.081,3.53-0.385,2.97-2.158l-5.848-18.483   l15.595-11.516c1.495-1.104,0.725-3.477-1.134-3.491l-19.385-0.15l-6.133-18.39C213.737,171.579,211.243,171.579,210.654,173.342z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSb);
export default __webpack_public_path__ + "static/media/SB.21a7c25db728dbd1b2038165e010eb24.svg";
export { ForwardRef as ReactComponent };